// -----------------------------------------------------------------
// Path: src/app/app.config.ts (UPDATED)
// -----------------------------------------------------------------
// This is the new central place for application-wide provider configuration.

import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';

import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { enUS } from 'date-fns/locale';
import { APP_DATE_FORMAT } from './shared/utils/date-format';

// Create a custom locale that uses our standard app date format
const appStandardLocale = {
  ...enUS,
  formatLong: {
    ...enUS.formatLong,
    date: () => APP_DATE_FORMAT,
    time: () => 'HH:mm:ss',
    dateTime: () => `${APP_DATE_FORMAT} HH:mm:ss`
  }
};

const MY_DATE_FORMATS = {
  parse: {
    dateInput: APP_DATE_FORMAT,
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: APP_DATE_FORMAT,
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: APP_DATE_FORMAT,
    monthYearA11yLabel: 'MMMM yyyy',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    provideHttpClient(withInterceptorsFromDi()),

    provideAnimationsAsync(),

    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },

    provideZonelessChangeDetection(),

    provideDateFnsAdapter(), // No locale specified here, as it's provided via MAT_DATE_LOCALE
    { provide: MAT_DATE_LOCALE, useValue: appStandardLocale },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ]
};
